import React from 'react';

const StatisticsIcon = ({ style }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
        style={style}
    >
        <path d="M6 16H10V-3.05176e-05H6V16ZM0 16H4V7.99997H0V16ZM12 4.99997V16H16V4.99997H12Z" />
    </svg>
);
export default StatisticsIcon;
